module.exports = __webpack_public_path__ + "static/media/icon-rss.84c281de.svg";